module.exports = __webpack_public_path__ + "img/Pfizer.ef09daa6.jpg";